import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareMinus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareMinus"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM8.00005 10.9999L7.99998 12.9999L16 13.0003L16.0001 11.0003L8.00005 10.9999Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareMinus;
